"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var lodash_1 = require("lodash");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var hooks_1 = require("utils/hooks");
var MarkCompleted = function (_a) {
    var _b;
    var item = _a.item;
    var _c = __read((0, hooks_1.useSubmitter)('stripe_paid_payout_events', item.id, {
        needsProcessing: false, markedCompletionManually: true,
    }), 2), markCompleted = _c[0], isSending = _c[1];
    var isProbablyCompleted = item.feeBankTxnAccountingId && item.transferAccountingId && item.paymentsSummary
        && (0, lodash_1.isEmpty)(item.paymentsSummary.failedInvs) && (0, lodash_1.isEmpty)(item.paymentsSummary.txnsWithInvoiceWithNoId)
        && ((_b = item.balanceMismatches) === null || _b === void 0 ? void 0 : _b.length) && Math.abs(item.balanceMismatches.reduce(function (acc, el) { return acc + el; })) < 0.001;
    return ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return markCompleted(); }, isSending: isSending, disabled: !isProbablyCompleted, color: "azzurro" }, { children: "Mark as completed" })));
};
exports.default = MarkCompleted;
